import * as React from "react"
import { SVGProps } from "react"

export const HamburgerIcon = ({ fill = "#444", ...props }: SVGProps<SVGSVGElement> & { fill?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="2.4em" height="2.4em" fill="none" viewBox="0 0 20 20" {...props}>
    <rect width={16} height={2} x={2} y={3} fill={fill} rx={1} />
    <rect width={16} height={2} x={2} y={9} fill={fill} rx={1} />
    <rect width={16} height={2} x={2} y={15} fill={fill} rx={1} />
  </svg>
)
